import React, { PureComponent, KeyboardEvent } from 'react';
import { Input, InputProps } from '@inplayer-org/inplayer-ui';

interface OwnProps {
  onEnterKey?: (e?: any) => any;
  onEscapeKey?: (e?: any) => any;
  validationOnEnter?: (value?: string) => boolean;
  type?: string;
}

type Props = InputProps & OwnProps;

const KEYS = {
  ENTER: 13,
  ESCAPE: 27,
};

class TextInput extends PureComponent<Props> {
  static defaultProps = {
    type: 'text',
    validationOnEnter: () => true,
  };

  onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();

    if (e.keyCode === KEYS.ENTER) {
      this.onEnter(e);
      return;
    }

    if (e.keyCode === KEYS.ESCAPE) {
      this.onEscape(e);
    }
  };

  onEnter = (e: KeyboardEvent<HTMLInputElement>) => {
    const { onEnterKey, validationOnEnter } = this.props;
    const target = e.target as HTMLInputElement;

    if (!onEnterKey || !validationOnEnter!(target.value)) {
      return;
    }

    onEnterKey(e);
  };

  onEscape = (e: KeyboardEvent<HTMLInputElement>) => {
    const { onEscapeKey } = this.props;

    if (!onEscapeKey) {
      return;
    }

    onEscapeKey(e);
  };

  render() {
    const { onEnterKey, onEscapeKey, ...allOtherProps } = this.props;
    return <Input onKeyDown={this.onKeyDown} {...allOtherProps} />;
  }
}

export default TextInput;
